export const commandIntegrationTypesEnum = {
  guildInstall: 0,
  userInstall: 1,
};

export const commandContextsEnum = {
  guild: 0,
  botDm: 1,
  privateChannel: 2,
};

export const commandOptionTypesEnum = {
  string: 3,
  integer: 4,
  boolean: 5,
  user: 6,
  channel: 7,
  role: 8,
  mentionable: 9,
  number: 10,
  attachment: 11,
};